import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro de la factura PDF de AccuWeather -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// AccuWeather tiene DOS formatos reales en circulacion (mismo proveedor, template cambio en algun
// punto de 2026): el viejo en espanol (verificado contra el PDF real archivado en Storage de la
// factura 162879) y el nuevo en ingles (verificado contra Invoice-XHHL3AMP-0001.pdf). Se detectan
// por "Invoice number" (nuevo) vs todo lo demas (viejo). Obligatorios (throw) en ambos: folio, monto.
export const parsearAccuweatherDesdeTexto = (texto) => {
  if (texto.includes("Invoice number")) return parsearFormatoNuevo(texto);
  return parsearFormatoViejo(texto);
};

// Formato nuevo (ingles). Anclas verificadas sobre el texto real de pdfjs de
// Invoice-XHHL3AMP-0001.pdf (sin normalizar espacios: el guion del folio sale como U+0000, igual
// que en Anthropic -> ../anthropic.js).
// eslint-disable-next-line no-control-regex -- U+0000 es el guion real del folio en el texto de pdfjs.
const NULO = new RegExp("\\u0000", "g");

const parsearFormatoNuevo = (texto) => {
  // folio: entre "Invoice number" y "Date of issue" -> U+0000 -> "-", quitar espacios ->
  // "XHHL3AMP-0001". Obligatorio.
  const mFolio = texto.match(/Invoice number([\S\s]*?)Date of issue/);
  if (!mFolio) throw new Error("No se reconoce el formato de factura AccuWeather (falta Invoice number)");
  const folio = mFolio[1].replace(NULO, "-").replace(/\s+/g, "").trim();
  if (!folio) throw new Error("No se pudo leer el numero de factura AccuWeather");

  // monto: "Amount due   $25.00 USD" (punto decimal, coma de miles). NUNCA los $0.00 de las lineas
  // de uso (Qty/Unit price/Amount por linea) -> ancla exclusiva a "Amount due". Obligatorio.
  const mMonto = texto.match(/Amount due\s*\$\s*([\d,]+\.\d{2})\s*USD/);
  if (!mMonto) throw new Error("No se pudo leer el Amount due de la factura AccuWeather");
  const monto = Number(mMonto[1].replace(/,/g, ""));

  // fecha: tras "Date of issue" -> "September 3, 2026" (Month DD, YYYY). Best-effort.
  const mFecha = texto.match(/Date of issue\s*([A-Za-z]+\s+\d{1,2},\s*\d{4})/);
  const fecha = mFecha ? parseFecha(mFecha[1]) : null;

  // concepto: fijo "Core Weather Standard" (nombre del plan, sin el "Monthly Fee (per seat)").
  const mConcepto = texto.match(/(Core Weather Standard)/);
  const concepto = mConcepto ? mConcepto[1] : "";

  // unidades: Qty de la linea "Core Weather Standard Monthly Fee (per seat) ... 1   $25.00   $25.00"
  // -> 1. Ancla a "Monthly Fee (per seat)" para no agarrar el Qty (11,903) de la linea de Usage.
  const mUnidades = texto.match(/Monthly Fe{2} \(per seat\)[\S\s]*?(\d+)(?:\s+\$[\d.]+){2}/);
  const unidades = mUnidades ? Number(mUnidades[1]) : null;

  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto, monto, moneda: "USD", unidades };
};

// Formato viejo (espanol). Anclas verificadas sobre el texto real de pdfjs (normalizado) del PDF
// archivado en Storage de la factura 162879.
const parsearFormatoViejo = (texto) => {
  // pdfjs mete espacios multiples entre palabras -> normalizar a un solo espacio antes de anclar.
  const t = texto.replace(/\s+/g, " ");

  // folio: "Numero de factura 178408" -> 178408. Obligatorio.
  const mFolio = t.match(/N[uú]mero de factura\s+(\d+)/);
  if (!mFolio) throw new Error("No se reconoce el formato de factura AccuWeather (falta Numero de factura)");
  const folio = mFolio[1];

  // monto: "25,00 $ USD" (coma decimal). NUNCA "Monto a Pagar 0,00 $" ni "Pagado -25,00 $" (no llevan
  // "$ USD" a la derecha). Obligatorio.
  const mMonto = t.match(/([\d.]*\d,\d{2})\s+\$\s+USD/);
  if (!mMonto) throw new Error("No se pudo leer el monto de la factura AccuWeather");
  const monto = Number(mMonto[1].replace(/\./g, "").replace(",", "."));

  // fecha: "Facturados De 2 Jul 2026" (D Mon YYYY). Best-effort.
  const mFecha = t.match(/Facturados De\s+(\d{1,2} [A-Za-z]+ \d{4})/);
  const fecha = mFecha ? parseFecha(mFecha[1]) : null;

  // concepto: "AccuWeather; Core Weather Standard; Base Fee" -> "Core Weather Standard". Best-effort.
  const mConcepto = t.match(/AccuWeather;\s*(.+?);/);
  const concepto = mConcepto ? mConcepto[1].trim() : "";

  // unidades: "Base Fee 1 25,00 $" -> 1. Best-effort.
  const mUnidades = t.match(/Base Fee\s+(\d+)\s+[\d.]*\d,\d{2}/);
  const unidades = mUnidades ? Number(mUnidades[1]) : null;

  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto, monto, moneda: "USD", unidades };
};
